<div class="modal-header">
  <h4 class="">{{modalText}}</h4>
</div>
<p class="modal-text modal-body" [innerHtml]="modcontent"></p>
<div class="modal-body">
  <div class="progress">
    <div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" arole="progressbar" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100" [style.width]="changeWidth()+'%'">
        {{changeWidth()+'%'}}
    </div>
  </div>

</div>
